export const countWords = (text) => {
  const matched = (text && text.match(/\S+/g)) || []
  return (matched && matched.length) || 0
}
